/*!**************************Confidential and Proprietary*****************************
* File Name: BarChart.ts
********************Copyright (c) Hyland Software, Inc. 1992-2023********************/

import { DataChartModel, CHART_TYPE } from './Models'

export class BarChart {
    public Chart: any = null;

    private token: string = null;
    private InstanceID: any = null;
    private ChartType: any = null;
    private IsHorizontal: boolean = null;
    private Legend: any = null;
    private ChartContainer: any = null;

    constructor(public Container, public Model: DataChartModel) {
        this.InstanceID = typeof (Model.instanceID) === 'undefined' ? 0 : Model.instanceID;
        this.Container = typeof (Container) === 'string' ? $('#' + Container) : Container;
        this.Model = Model;
        this.IsHorizontal = Model.chartType === CHART_TYPE.HorizontalBar;
    }

    public Render() {
        const self = this;

        if (this.ChartContainer !== null) {
            this.Container.empty();
        }
        this.ChartContainer = $('<div>')
            .addClass('chart bar')
            .attr('id', 'chart_' + this.InstanceID);
        this.Container.append(this.ChartContainer);

        const dataSplit = splitData(this.Model.data);
        const series = getBarSeries(dataSplit);

        let axes: any = [
            {
                name: 'yAxis',
                type: 'numericY',
                minimumValue: 0
            },
            {
                name: 'xAxis',
                type: 'categoryX',
                dataSource: this.Model.data,
                overlap: 1,
                label: 'Label',
                interval: 1,
                labelVisibility: this.Model.displayLabels ? 'visible' : 'collapsed'
            }
        ];

        if (this.IsHorizontal) {
            axes = [
                {
                    name: 'yAxis',
                    type: 'categoryY',
                    dataSource: this.Model.data,
                    overlap: 1,
                    label: 'Label',
                    interval: 1,
                    labelVisibility: this.Model.displayLabels ? 'visible' : 'collapsed'
                },
                {
                    name: 'xAxis',
                    type: 'numericX',
                    minimumValue: 0
                }
            ];
        }

        this.Chart = this.ChartContainer.igDataChart({
            width: '100%',
            height: '99%',
            plotAreaBackground: 'transparent',
            axes: axes,
            series: series,
            seriesMouseLeftButtonDown: function (e, ui) {
                self.Model.methods.itemClicked(ui.item);
            },
            tooltipShowing: function (evt, ui) {
                const value = ui.item.Value;
                // Do not display tooltips where the value returns NaN
                if (isNaN(value)) {
                    return false;
                }
            },
            title: this.Model.title
        });
        function splitData(data) {
            const output = [];

            for (let i = 0; i < data.length; i++) {
                let title = '';
                const arr = data.map(function (item, j) {
                    if (i === j) {
                        title = item['LabelEncoded'];
                        return item;
                    }
                    const ret = {}
                    for (const prop in item) {
                        if (item.hasOwnProperty(prop)) {
                            ret[prop] = item[prop];
                        }
                    }
                    if (title !== ret['LabelEncoded']) {
                        ret['Value'] = NaN;
                    }
                    return ret;
                });
                arr.title = title;

                output.push(arr);
            }

            return output;
        }

        function getBarSeries(data) {
            return data.map(function (item, i) {
                const strRcOthers = self.Model.strings !== null && typeof (self.Model.strings.STR_RC_OTHERS) === 'string' ? self.Model.strings.STR_RC_OTHERS : 'Others';
                const seriesObj: any = {
                    name: 'series' + i,
                    title: item.title,
                    dataSource: item,
                    type: self.IsHorizontal ? 'bar' : 'column',
                    isHighlightingEnabled: true,
                    isTransitionInEnabled: true,
                    yAxis: 'yAxis',
                    xAxis: 'xAxis',
                    valueMemberPath: 'Value',
                    showTooltip: true,
                    othersCategoryText: strRcOthers,
                    tooltipTemplate: '<div> {{if ${item.Label}.length > 0 }} <div class="bold">${item.Label}</div><div>${item.Value}</div> {{else}} <div class="bold">' + strRcOthers + '</div>{{/if}}</div>',
                }

                let color = item[i].Color;
                if (typeof (color) !== 'undefined' && color !== null) {
                    color = '#' + color;
                    seriesObj.brush = color;
                    seriesObj.outline = color;
                }

                return seriesObj;
            });
        }

        this.RenderLegend();

        if ($('html').css('direction') === 'rtl') {
            this.ChartContainer.css('direction', 'ltr');
            this.ChartContainer.igDataChart('option', 'axes', [
                {
                    name: 'yAxis',
                    labelHorizontalAlignment: 'right',
                    labelLocation: 'outsideRight'
                },
                {
                    name: 'xAxis',
                    isInverted: true
                }
            ]);
        }
    }

    public GetImage() {
        const image = this.ChartContainer.igDataChart('exportImage', this.ChartContainer.width(), this.ChartContainer.height());
        return $(image).attr('src');
    }

    public RotateRight() {
        this.IsHorizontal = !this.IsHorizontal;
        if (typeof (this.Legend) !== 'undefined' && this.Legend !== null) {
            this.Legend.remove();
            this.Legend = null;
        }
        this.Render();
    }

    public ToggleLegend() {
        this.Model.displayLegend = !this.Model.displayLegend;

        if (this.Model.displayLegend) {
            this.RenderLegend();
        }
        else if (this.Legend !== null) {
            this.Legend.hide();
            this.ChartContainer.igDataChart({
                width: '90%'
            });
        }
    }

    public ToggleLabels() {
        this.Model.displayLabels = !this.Model.displayLabels;
        const labelIndex = this.IsHorizontal ? 0 : 1;
        const axes = this.ChartContainer.igDataChart('option', 'axes');
        let labelVisibility = 'collapsed';
        if (this.Model.displayLabels) {
            labelVisibility = 'visible';
        }
        axes[labelIndex].labelVisibility = labelVisibility;

        this.ChartContainer.igDataChart('option', 'axes', axes);
    }


    public Print() {
        this.ChartContainer.igDataChart('print');
    }

    private RenderLegend() {
        if (this.Model.displayLegend) {
            const legendID = 'legend_' + this.InstanceID;

            if (this.Legend === null) {
                this.Legend = $('<div>')
                    .addClass('legend')
                    .attr('id', legendID);
                this.Container.append(this.Legend);
            }
            else {
                this.Legend.show();
            }

            this.ChartContainer.igDataChart({
                legend: { element: legendID },
                width: '60%'
            });
        }
    }
}
